export const instructions = [
  {
    link: '/',
    title: 'All fields marked "*" must be completed.',
  },
  {
    link: '/',
    title: 'Use the "Save as Draft" button to save your changes.',
  },
  {
    link: '/',
    title: 'Use "Submit/Update" button to submit/Update your request.',
  },
  {
    link: '/',
    title: 'Use "Close" button to close the request.',
  },
]
